import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class PanierService {
	constructor(private http: HttpClient) { }

    get(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.panier:get',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

    set(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.panier:set',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

	delete(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.panier:delete',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	vider(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.panier:vider',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

}